<template>
  <div class="terms-conditions-page pt-5">
    <b-card>
      <h1>
        {{ $t('pages.primeInsightsGroupLlcPublisherTermsAndConditions') }}
      </h1>

      <hr>

      <!-- Card Content -->
      <div class="card-content">
        <p>
          {{ $t('pages.byRegisteringAsAPublisherOnThePrimeInsights') }}
        </p>
        <hr>

        <h2>{{ $t('pages.1EligibilityAndAccountRegistration') }}</h2>
        <ul>
          <li>
            <strong>{{ $t('pages.ageRequirement') }}</strong> {{ $t('pages.youMustBeAtLeastEighteen18YearsOld') }}
          </li>
          <li>
            <strong>{{ $t('pages.accurateInformation') }}</strong> {{ $t('pages.allInformationProvidedDuringRegistrationMustBeAccurateComplete') }}
          </li>
          <li>
            <strong>{{ $t('pages.compliance') }}</strong> {{ $t('pages.youMustHaveTheLegalAuthorityToEnterInto') }}
          </li>
        </ul>
        <hr>

        <h2>{{ $t('pages.2PublisherObligations') }}</h2>
        <ul>
          <li>
            <strong>{{ $t('pages.contentStandards') }}</strong> {{ $t('pages.yourApplicationsAndWebsitesMustNotContainIllegalDefamatory') }}
          </li>
          <li>
            <strong>{{ $t('pages.ownershipRights') }}</strong> {{ $t('pages.youMustOwnOrHaveTheRightsToAll') }}
          </li>
          <li>
            <strong>{{ $t('pages.userConsentAndPrivacy') }}</strong> {{ $t('pages.youAreResponsibleForObtainingAllNecessaryConsentsFrom') }}
          </li>
          <li>
            <strong>{{ $t('pages.noUnauthorizedModifications') }}</strong> {{ $t('pages.youMayNotModifyAlterOrInterfereWithThe') }}
          </li>
          <li>
            <strong>{{ $t('pages.fraudPrevention') }}</strong> {{ $t('pages.youMustMonitorAndPreventFraudulentActivitiesImmediateNotification') }}
          </li>
        </ul>
        <hr>

        <h2>{{ $t('pages.3ServicesProvidedByPrimeInsights') }}</h2>
        <ul>
          <li>
            <strong>{{ $t('pages.accessToPlatform') }}</strong> {{ $t('pages.weWillProvideAccessToThePlatformAndPublisher') }}
          </li>
          <li>
            <strong>{{ $t('pages.surveyDistribution') }}</strong> {{ $t('pages.weWillSupplySurveysFromOurAdvertisersForYou') }}
          </li>
          <li>
            <strong>{{ $t('pages.integrationTools') }}</strong> {{ $t('pages.weWillProvideNecessaryToolsAndSupportForIntegrating') }}
          </li>
          <li>
            <strong>{{ $t('pages.dataTracking') }}</strong> {{ $t('pages.weWillTrackPerformanceDataAndMakeStatisticsAvailable') }}
          </li>
          <li>
            <strong>{{ $t('pages.supportServices') }}</strong> {{ $t('pages.weWillOfferTechnicalSupportToAssistYouAnd') }}
          </li>
        </ul>
        <hr>

        <h2>{{ $t('pages.4PaymentTerms') }}</h2>
        <ul>
          <li>
            <strong>{{ $t('pages.commissionStructure') }}</strong> {{ $t('pages.youWillEarnCommissionsForValidUserActivitiesSuch') }}
          </li>
          <li>
            <strong>{{ $t('pages.paymentThreshold') }}</strong> {{ $t('pages.paymentsWillBeIssuedMonthlyWhenYourAccruedEarnings') }}
          </li>
          <li>
            <strong>{{ $t('pages.paymentSchedule') }}</strong> {{ $t('pages.paymentsWillBeProcessedWithin60CalendarDaysAfter') }}
          </li>
          <li>
            <strong>{{ $t('pages.adjustmentsAndChargebacks') }}</strong> {{ $t('pages.advertisersMayInvalidateAUserSParticipationDueTo') }}
          </li>
          <li>
            <strong>{{ $t('pages.taxesAndFees') }}</strong> {{ $t('pages.youAreResponsibleForAllApplicableTaxesPrimeInsights') }}
          </li>
        </ul>
        <hr>

        <h2>{{ $t('pages.5ComplianceAndRepresentations') }}</h2>
        <ul>
          <li>
            <strong>{{ $t('pages.legalCompliance') }}</strong> {{ $t('pages.eachPartyAgreesToComplyWithAllApplicableLaws') }}
          </li>
          <li>
            <strong>{{ $t('pages.representationsAndWarranties') }}</strong> {{ $t('pages.youRepresentAndWarrantThatYourContentDoesNot') }}
          </li>
          <li>
            <strong>{{ $t('pages.notifications') }}</strong> {{ $t('pages.eachPartyMustPromptlyNotifyTheOtherPartyOf') }}
          </li>
        </ul>
        <hr>

        <h2>{{ $t('pages.6ConfidentialityAndDataProtection') }}</h2>
        <ul>
          <li>
            <strong>{{ $t('pages.confidentialInformation') }}</strong> {{ $t('pages.confidentialInformationMeansAnyInformationOfAPartyDisclosing') }}
            <ol type="i">
              <li>
                {{ $t('pages.isNotAsAWholeOrInItsComponents') }}
              </li>
              <li>
                {{ $t('pages.hasActualOrPotentialCommercialValueBecauseOfIts') }}
              </li>
              <li>
                {{ $t('pages.disclosingPartyHasTakenReasonableStepsUnderTheCircumstances') }}
              </li>
              <li>
                {{ $t('pages.isFurnishedAfterTheEffectiveDateByOrOn') }}
              </li>
            </ol>
            {{ $t('pages.eachReceivingPartyAgreesToSafeguardDisclosingPartyS') }}
            <ol type="i">
              <li>
                {{ $t('pages.useDisclosingPartySConfidentialInformationForAnyPurpose') }}
              </li>
              <li>
                {{ $t('pages.copyOrOtherwiseReproduceDisclosingPartySConfidentialInformation') }}
              </li>
            </ol>
            {{ $t('pages.notwithstandingAnythingToTheContraryHereinTheFollowingWill') }}
            <ol type="i">
              <li>
                {{ $t('pages.confidentialityPreviouslyKnownInformation') }}
              </li>
              <li>
                {{ $t('pages.disclosingPartySInformationThatIsOrBecomesGenerally') }}
              </li>
              <li>
                {{ $t('pages.disclosingPartySInformationThatIsOrBecomesAvailable') }}
              </li>
              <li>
                {{ $t('pages.confidentialityIndependentlyDevelopedInformation') }}
              </li>
              <li>
                {{ $t('pages.disclosingPartySInformationForWhichTheDisclosingParty') }}
              </li>
            </ol>
            {{ $t('pages.furthermoreReceivingPartyShallNotBeDeemedToBe') }}
          </li>
          <li>
            <strong>{{ $t('pages.dataProtection') }}</strong> {{ $t('pages.bothPartiesWillComplyWithAllApplicableDataProtection') }}
          </li>
          <li>
            <strong>{{ $t('pages.userPrivacy') }}</strong> {{ $t('pages.eachPartyMustProtectUserDataAndEnsureIt') }}
          </li>
          <li>
            <strong>{{ $t('pages.childrenSPrivacy') }}</strong> {{ $t('pages.ifAPartyCollectsDataFromChildrenUnder13') }}
          </li>
        </ul>
        <hr>

        <h2>{{ $t('pages.7IntellectualPropertyRights') }}</h2>
        <ul>
          <li>
            <strong>{{ $t('pages.licenseGrant') }}</strong> {{ $t('pages.primeInsightsGrantsYouANonExclusiveNonTransferable') }}
          </li>
          <li>
            <strong>{{ $t('pages.ownership') }}</strong> {{ $t('pages.allIntellectualPropertyRightsInThePlatformAndServices') }}
          </li>
        </ul>
        <hr>

        <h2>{{ $t('pages.8Termination') }}</h2>
        <ul>
          <li>
            <strong>{{ $t('pages.terminationByEitherParty') }}</strong> {{ $t('pages.thisAgreementMayBeTerminatedByEitherPartyWith') }}
          </li>
          <li>
            <strong>{{ $t('pages.immediateTermination') }}</strong> {{ $t('pages.eachPartyMayTerminateThisAgreementImmediatelyIfThe') }}
          </li>
          <li>
            <strong>{{ $t('pages.effectOfTermination') }}</strong> {{ $t('pages.uponTerminationYouMustCeaseAllUseOfThe') }}
          </li>
        </ul>
        <hr>

        <h2>{{ $t('pages.9LimitationOfLiability') }}</h2>
        <ul>
          <li>
            <strong>{{ $t('pages.disclaimer') }}</strong> {{ $t('pages.thePlatformAndServicesAreProvidedAsIsWithout') }}
          </li>
          <li>
            <strong>{{ $t('pages.limitation') }}</strong> {{ $t('pages.exceptWithRespectToAnyBreachOfConfidentialityObligations') }}
          </li>
          <li>
            <strong>{{ $t('pages.noLiabilityForIndirectDamages') }}</strong> {{ $t('pages.neitherPartyWillBeLiableForIndirectIncidentalConsequential') }}
          </li>
        </ul>
        <hr>

        <h2>{{ $t('pages.10Indemnification') }}</h2>
        <ul>
          <li>
            <strong>{{ $t('pages.yourObligations') }}</strong> {{ $t('pages.eachPartyAgreesToIndemnifyAndHoldHarmlessThe') }}
          </li>
          <li>
            <strong>{{ $t('pages.procedure') }}</strong> {{ $t('pages.theIndemnifiedPartyWillNotifyTheIndemnifyingPartyPromptly') }}
          </li>
        </ul>
        <hr>

        <h2>{{ $t('pages.11GeneralProvisions') }}</h2>
        <ul>
          <li>
            <strong>{{ $t('pages.entireAgreement') }}</strong> {{ $t('pages.thisAgreementConstitutesTheEntireUnderstandingBetweenTheParties') }}
          </li>
          <li>
            <strong>{{ $t('pages.amendments') }}</strong> {{ $t('pages.anyModificationsToThisAgreementMustBeInWriting') }}
          </li>
          <li>
            <strong>{{ $t('pages.assignment') }}</strong> {{ $t('pages.neitherPartyMayAssignOrDelegateItsRightsOr') }}
          </li>
          <li>
            <strong>{{ $t('pages.governingLaw') }}</strong> {{ $t('pages.thisAgreementIsGovernedByTheLawsOfThe') }}
          </li>
          <li>
            <strong>{{ $t('pages.disputeResolution') }}</strong> {{ $t('pages.anyDisputesWillBeResolvedThroughBindingArbitrationUnder') }}
          </li>
          <li>
            <strong>{{ $t('pages.notices') }}</strong> {{ $t('pages.allNoticesMustBeInWritingAndSentTo') }}
          </li>
          <li>
            <strong>{{ $t('pages.severability') }}</strong> {{ $t('pages.ifAnyProvisionIsDeemedUnenforceableTheRemainingTerms') }}
          </li>
          <li>
            <strong>{{ $t('pages.waiver') }}</strong> {{ $t('pages.failureToEnforceAnyProvisionDoesNotConstituteA') }}
          </li>
          <li>
            <strong>{{ $t('pages.independentContractors') }}</strong> {{ $t('pages.thePartiesAreIndependentContractorsThisAgreementDoesNot') }}
          </li>
        </ul>
        <hr>

        <p class="mb-0">
          {{ $t('pages.byUsingThePrimeInsightsPlatformOrIntegratingOur') }}
        </p>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'TermsConditions',
}
</script>

<style scoped>
.terms-conditions-page {
  padding: 30px;
}

.card-content {
  margin-top: 20px;
  line-height: 1.8;
  font-size: 16px;
}

/* Headings */
h2 {
  margin-top: 30px;
  margin-bottom: 15px;
}

/* Paragraphs */
p {
  margin-bottom: 20px;
}

/* Unordered lists */
ul {
  list-style: disc;
  padding-left: 25px;
  margin-bottom: 20px;
}

/* List items for more spacing */
ul li {
  margin-bottom: 10px;
}

/* Ordered lists */
ol {
  list-style-type: lower-alpha;
  padding-left: 25px;
  margin-bottom: 10px;
}

/* Horizontal rules */
hr {
  margin: 30px 0;
}
</style>
